import { graphql } from "@opensea/graphql"
import { CurrencyAboutFragment } from "../CurrencyAbout/CurrencyAbout.fragment"
import { CurrencyBannerMediaFragment } from "../CurrencyBannerMedia/CurrencyBannerMedia.fragment"
import { CurrencyChartFragment } from "./CurrencyChart.fragment"
import { CurrencyStatsFragment } from "./CurrencyStats.fragment"
import { CurrencySwapModuleFragment } from "./CurrencySwapModule.fragment"
import { WalletPositionStatsFragment } from "./WalletPositionStats.fragment"

export const CurrencyModuleFragment = graphql(
  `
    fragment CurrencyModule on Currency {
      symbol
      isSwapDisabled
      metadata {
        overview {
          modules {
            __typename
          }
        }
      }
      ...CurrencyChart
      ...CurrencySwapModule
      ...CurrencyStats
      ...CurrencyAbout
      ...CurrencyBannerMedia
      ...WalletPositionStats
    }
  `,
  [
    CurrencyChartFragment,
    CurrencySwapModuleFragment,
    CurrencyStatsFragment,
    CurrencyAboutFragment,
    CurrencyBannerMediaFragment,
    WalletPositionStatsFragment,
  ],
)
